<template>
<v-container fluid>
  <v-row dense>
    <v-col cols="12">
      <DataTable :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
    </v-col>
    <v-col cols='12' sm='6'>
      <ViewDetails :object="object" type="DetailEquipo" :actions="tableAction" />
    </v-col>
  </v-row>
    <MainFormDialog v-if="get_dialogMain.dialog" :model="objectMain" :params="paramsMain" />
</v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import DataTable from '@/components/dataTableMain'
import MainFormDialog from '@/components/dialog/main/MainFormDialog'
import ViewDetails from '@/components/ViewDetails'
import { Permission } from '@/mixins/permissionMain'

export default {
  mixins: [Permission],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'NewData', code: 'inventario.insumos-create' }
        ],
        titles: [
          { text: 'Folio', value: 'folio', class: 'black--text' },
          { text: 'Insumo', value: 'NombreEquipo', class: 'black--text' },
          { text: 'Marca-Modelo', value: 'MarcaModelo', class: 'black--text' },
          { text: 'Departamento', value: 'descripcion.departamento.nombre', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    objectMain: {},
    paramsMain: {}
  }),
  components: {
    DataTable,
    MainFormDialog,
    ViewDetails
  },
  mounted () {
    this.getDataUrl('inventario.insumos-list')
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'urlGetServicesActionList']),
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getDataUrl('inventario.insumos-list')
    },
    NewData (item) {
      this.paramsMain = {
        family: true,
        urloption: this.get_urls['inventario.options'],
        process: 3,
        urlprocess: this.get_urls['inventario.execute'],
        message: 'Registro Agregado Correctamente'
      }
      this.SHOW_DIALOG_MAIN({ type: 'create', form: 'process', with: 900, title: 'Nuevo Insumo' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.urlGetServicesActionList({ url: router, data: {} })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objects']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) {
      this.getDataUrl('inventario.list')
    },
    get_objects (vals) {
      if (vals) {
        this.table.body.data = vals
        if (vals.length > 0) {
          this.table.modelMain = []
          this.table.modelMain.push(vals[0])
        }
        this.table.body.data = vals
        this.table.header.loading = false
      }
    }
  }
}
</script>

<style>
</style>
